__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/89b91bb840ecc7bf99a83af776a0b8d6f1cba670b03cc7579e1fd6e5/";